import React, { Component } from 'react';
import { OrderList } from './OrderList';
import { OrderDtl } from './OrderDtl';
import { OrderDtlExcel } from './OrderDtlExcel';
import { CompletedList } from './CompletedList';

import { HeaderSub2 } from '../../Common/HeaderSub2'
import { HeaderSub } from '../../Common/HeaderSub'
import { Footer } from '../../Common/Footer'

import { RtiDtlAp } from '../../Retail/MyRetail/RtiDtlAp'
import { DealHistory } from '../../Retail/MyRetail/DealHistory'

import { GoodsDtl } from '../../Goods/GoodsMgr/GoodsDtl';
import { GoodsZoom } from '../../Goods/GoodsMgr/GoodsZoom';

import { Big3Common } from '../../../js/IncludeManager'
/* 개발담당:양유빈
 * 화면기능:주문관리 메인
 * 세부설명:
*/

export class Index extends Component {
    static displayName = Index.name;

    constructor(props) {
        super(props);
        this.state = {
            RenderName: this.CompName.OrderList,  //기본 컴포넌트 할당
            ContentState: null,
            OutSideBackUrl: this.CompName.OrderList //다른 구룹의 링크를 설정하기 위한 속성
        };
        this.CsName = Big3Common.ContentState;
    }
    CompName = {
        "OrderList": "OrderList",
        "OrderDtl": "OrderDtl",
        "OrderDtlExcel": "OrderDtlExcel",
        "CompletedList": "CompletedList",       
        "RtiDtlAp": "RtiDtlAp",
        "DealHistory": "DealHistory",
        "GoodsDtl": "GoodsDtl",
        "GoodsZoom": "GoodsZoom"
    }

    //초기화
    componentDidMount() {
       
        const Param_alim_idx = Big3Common.Util.GetParams("alim_idx");        
        const Param_Qstgrp_no = Big3Common.Util.GetParams("ordgrp_no");        
        const Param_Ord_status = Big3Common.Util.GetParams("ord_status");
        const Param_Union_uid = Big3Common.Util.GetParams("union_uid");
        //주문상세로 직접이동
        if (Param_alim_idx !== null && Param_Qstgrp_no !== null) {
            const ContentState = {
                [this.CsName.Ordgrp_No]: Param_Qstgrp_no,
                [this.CsName.Ord_Status]: Param_Ord_status,
                [this.CsName.Union_Uid]: Param_Union_uid
            }
            this.setState({
                ContentState: ContentState,
                RenderName: this.CompName.OrderDtl
            });
        }
    }
    componentWillUnmount() {
        Big3Common.HistoryBackToClearBackdoor();
    }
    Footerrender() {
        return (
                <Footer
                fillName="icon2"
                ComponentName={this.state.RenderName}
                />
            )
    }
    render() {
        let Footerrender = this.Footerrender();
        if (this.state.RenderName === this.CompName.OrderList) {
            //주문,포장완료
            //OutSideBackUrl은 주문상세에서 이전 화면으로 돌아가기 위한 URL(여기에서만 사용됨)
            return (
                <div>
                    <HeaderSub2
                        HeaderTitle="주문목록"
                        HistoryBack={true}
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <OrderList
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState, OutSideBackUrl: this.state.RenderName })}
                        ContentState={this.state.ContentState}                        
                    />
                    {Footerrender}
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.OrderDtl) {
            //주문상세(온라인)
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="매장주문 상세"
                        ComponentUrl={this.state.OutSideBackUrl}
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <OrderDtl
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.OrderDtlExcel) {
            //주문상세(엑셀)
            return (
                <div>
                    <HeaderSub2
                        HeaderTitle="엑셀주문 현황"
                        ComponentUrl={this.state.OutSideBackUrl}
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <OrderDtlExcel
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState})}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.CompletedList) {
            //거래완료, 취소완료
            return (
                <div>
                    <HeaderSub2
                        HeaderTitle="주문목록"
                        HistoryBack={true}
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <CompletedList
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState, OutSideBackUrl: this.state.RenderName })}
                        ContentState={this.state.ContentState}
                    />
                    {Footerrender}
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.RtiDtlAp) {
            //거래처 정보
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="거래처 정보"
                        ComponentUrl={this.state.OutSideBackUrl}
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <RtiDtlAp
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.DealHistory) {
            //거래처 거래내역
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="거래내역"
                        ComponentUrl="RtiDtlAp"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <DealHistory
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.GoodsDtl) {
            //제품상세
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="제품상세"
                        ComponentUrl="OrderDtl"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <GoodsDtl
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.GoodsZoom) {
            //상품 Zoom 기능
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="제품상세"
                        ComponentUrl="GoodsDtl"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <GoodsZoom
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
    }
}
